import { Card, CardContent } from "@/components/ui/card";

export function MonthlyStatsTable({ title, stats }) {
  if (!stats) return null;

  const fmt = (v) => v != null && v !== 0 ? `€ ${Number(v).toFixed(2)}` : "—";

  const rows = [
    { label: "Dias trabalhados", value: stats.days_worked ?? "—", cost: fmt(stats.days_cost) },
    { label: "Pedidos", value: stats.orders ?? "—", cost: fmt(stats.orders_cost) },
    { label: "Distância percorrida", value: stats.distance_km != null ? `${Number(stats.distance_km).toFixed(1)} km` : "—", cost: fmt(stats.distance_cost) },
    { label: "% Frete", value: stats.shipping_total != null ? `€ ${Number(stats.shipping_total).toFixed(2)}` : "—", cost: fmt(stats.shipping_cost) },
  ];

  return (
    <Card className="flex-1" data-testid={`stats-${title.toLowerCase().replace(/\s/g, "-")}`}>
      <CardContent className="p-4">
        <h3 className="font-semibold text-sm mb-3 text-muted-foreground uppercase tracking-wide">{title}</h3>
        <div className="space-y-2">
          {rows.map((r, i) => (
            <div key={i} className="flex items-center justify-between py-1.5 border-b border-border/30 last:border-0 gap-2">
              <span className="text-sm text-muted-foreground flex-1 min-w-0 truncate">{r.label}</span>
              <span className="text-sm font-medium tabular-nums shrink-0">{r.value}</span>
              <span className="text-sm font-medium text-emerald-500 tabular-nums shrink-0 w-20 text-right">{r.cost}</span>
            </div>
          ))}
          <div className="flex items-center justify-between pt-2 font-bold">
            <span className="text-sm">Total</span>
            <span className="text-sm text-emerald-500 tabular-nums">{fmt(stats.total_cost)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
